import { useWrongNetwork } from '@/domain/hooks/useWrongNetwork'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { withSuspense } from '@/ui/utils/withSuspense'
import { Address } from 'viem'
import { EvcSwapDebtDialogContent } from './EvcSwapDebtDialogContent'

export interface EvcSwapDebtDialogProps extends CommonDialogProps {
  fromVault: Address
  fromSymbol: string
  fromDecimals: number
  fromAsset: Address
  fromLogoURI?: string
  currentDebt: string
  subAccountId?: number
  collateralVaults?: Address[]
}

function EvcSwapDebtDialogContainer(
  props: Omit<EvcSwapDebtDialogProps, 'open' | 'setOpen'> & { closeDialog: () => void },
) {
  return <EvcSwapDebtDialogContent {...props} />
}

const EvcSwapDebtDialogContainerWithSuspense = withSuspense(EvcSwapDebtDialogContainer, DialogContentSkeleton)

function EvcSwapDebtDialog({ open, setOpen, ...props }: EvcSwapDebtDialogProps) {
  const isWrongNetwork = useWrongNetwork()
  if (isWrongNetwork) {
    setOpen(false)
    return null
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent aria-describedby={undefined}>
        <EvcSwapDebtDialogContainerWithSuspense closeDialog={() => setOpen(false)} {...props} />
      </DialogContent>
    </Dialog>
  )
}

export const evcSwapDebtDialogConfig: DialogConfig<EvcSwapDebtDialogProps> = {
  options: {
    closeOnChainChange: true,
  },
  element: EvcSwapDebtDialog,
}
